/* eslint-disable max-len */
import { useEffect, useState, useCallback } from 'react'
import { debounce } from 'lodash'
import Spinner from 'react-spinkit'
import { useProvider } from '../../provider/Provider'
import { Container, Content, Filters } from './style'
import {
    changeArea, changeCity, changeLimit, changeQuery, changeSearch, changeType
} from '../../provider/actions'
import EntidadeItem from '../../components/EntidadeItem'
import TipoEntidade from '../../model/TipoEntidade'
import EntidadeService from '../../services/EntidadeService'

export default function BuscarEntidades() {
    const { entidades, dispatch } = useProvider()
    const {
        search, limit, type, area, city, admin
    } = entidades.query
    const { items, total, isLoading } = entidades
    const [inputValue, setInputValue] = useState('')
    const [tipoEntidades, setTipoEntidades] = useState<TipoEntidade[]>([])
    const [areasDeAtuacao, setAreasDeAtuacao] = useState<string[]>([])
    const [cidadesList, setCidades] = useState<string[]>([])
    const [loadingMore, setLoadingMore] = useState<boolean>(false)

    useEffect(() => {
        EntidadeService.getTipoEntidades().then((data) => {
            setTipoEntidades(data)
        })
        EntidadeService.getAreasAtuacao().then((data) => {
            const areas = data.map((a) => {return a.nome})
            setAreasDeAtuacao(Array.from(new Set(areas)))
        })
        EntidadeService.getLocalizacoes().then((data) => {
            const cidades = data.map((c) => {return c.cidade})
            setCidades(Array.from(new Set(cidades)))
        })
        if (limit > 6) {
            changeLimit(dispatch, 6)
        }
    }, [])

    useEffect(() => {
        const value = search ?? ''
        setInputValue(value)
    }, [search])

    useEffect(() => {
        if (!isLoading) setLoadingMore(false)
    }, [isLoading])

    const handler = useCallback(
        debounce((value) => {
            changeSearch(dispatch, value)
        }, 400), []
    )

    const onChangeSearch = (value: string) => {
        setInputValue(value)
        handler(value)
    }

    const getMore = () => {
        changeLimit(dispatch, limit + 6)
        setLoadingMore(true)
    }

    function hasMoreItems() {
        return items.length < total
    }

    const clearFilters = () => {
        changeQuery(dispatch, {
            limit: 6,
            page: 1,
            search: '',
            area: '',
            city: '',
            type: '',
            admin: false
        })
    }

    const hasFiltersOn = (): boolean => {
        return !!type || !!area || !!city || !!search || admin
    }

    function typesToSelectOptions() {
        return tipoEntidades.map((tipo) => {
            return <option key={tipo.nome}>{tipo.nome}</option>
        })
    }

    function areasToSelectOptions() {
        return areasDeAtuacao.map((areaItem) => {
            return <option key={areaItem}>{areaItem}</option>
        })
    }

    function cidadesToSelectOptions() {
        return cidadesList.map((cidade) => {
            return <option key={cidade}>{cidade}</option>
        })
    }

    const onSelectType = (tipo: string) => {
        changeType(dispatch, tipo)
    }

    const onSelectArea = (tipo: string) => {
        changeArea(dispatch, tipo)
    }

    const onSelectCity = (tipo: string) => {
        changeCity(dispatch, tipo)
    }

    return (
        <Container>
            <Content>
                <div className="input-group search mb-2">
                    <div className="input-group-prepend">
                        <span
                            className="input-group-text"
                            id="form1"
                        >
                            <i className="fas fa-search" />
                        </span>
                    </div>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Busque por startups,
                        aceleradoras, comunidades..."
                        aria-describedby="form1"
                        value={inputValue}
                        onChange={(e) => {onChangeSearch(e.target.value)}}
                    />
                </div>
                <Filters>
                    <div className="form-group">
                        <select
                            value={type}
                            className="form-control"
                            onChange={(e) => {onSelectType(e.currentTarget.value)}}
                        >
                            <option value="">Tipo de entidade</option>
                            {typesToSelectOptions()}
                        </select>
                    </div>
                    <div className="form-group">
                        <select
                            value={area}
                            className="form-control"
                            onChange={(e) => {onSelectArea(e.currentTarget.value)}}
                        >
                            <option value="">Area de atuação</option>
                            {areasToSelectOptions()}
                        </select>
                    </div>
                    <div className="form-group">
                        <select
                            value={city}
                            className="form-control"
                            onChange={(e) => {onSelectCity(e.currentTarget.value)}}
                        >
                            <option value="">Cidade</option>
                            {cidadesToSelectOptions()}
                        </select>
                    </div>
                    {
                        hasFiltersOn()
                            ? (
                                <div onClick={clearFilters} className="clear-filters">
                                    <i className="fas fa-eraser mr-2" />
                                    <span>Limpar filtros</span>
                                </div>
                            )
                            : false
                    }
                </Filters>
                <div className="mt-2">
                    <span>
                        <span>Encontramos </span>
                        <span>{total}</span>
                        <span> resultados para sua busca</span>
                    </span>
                </div>
                <div className={`${isLoading && !loadingMore ? 'row hidden' : 'row'}`}>
                    {
                        items.map((item) => {
                            return <EntidadeItem ent={item} key={item.id} />
                        })
                    }
                </div>
                <div className={`${isLoading ? 'spinner-box' : 'hidden'}`}>
                    <Spinner
                        name="ball-clip-rotate-multiple"
                        color="#1A3549"
                        fadeIn="none"
                    />
                    <span>Buscando...</span>
                </div>
                {
                    hasMoreItems() && !isLoading
                        ? (
                            <div className="mais">
                                <div onClick={getMore}>Mostrar mais</div>
                            </div>
                        ) : false
                }
            </Content>
        </Container>
    )
}
